import { NgModule } from '@angular/core';

//#region modules
import { SharedModule } from '../shared/shared.module';
//#endregion

//#region componnets
import { SalesComponent } from './components/sales.component';
//#endregion

//#region services
import { DashboardService } from './dashboard.service';
//#endregion

@NgModule({
    declarations: [
        SalesComponent
    ],
    imports: [
        SharedModule,
    ],
    providers: [
        DashboardService
    ],
    exports: [
        SalesComponent
    ]
})
export class DashboardModule { }
